const MUI_SPACING_DEFAULT = 8;
export const GridPresets = (tokens) => {
    const { semantic: { layout: { mobile, tablet, desktop }, }, } = tokens;
    const getMuiSpacing = (spacingValue) => {
        return Math.round(spacingValue / MUI_SPACING_DEFAULT);
    };
    return {
        page: {
            container: true,
            spacing: {
                sm: getMuiSpacing(parseInt(mobile.columnGap.value)),
                md: getMuiSpacing(parseInt(tablet.columnGap.value)),
                lg: getMuiSpacing(parseInt(desktop.columnGap.value)),
            },
            columns: {
                sm: mobile.columns.value,
                md: tablet.columns.value,
                lg: desktop.columns.value,
            },
        },
    };
};
//# sourceMappingURL=grid.js.map